// removed by extract-text-webpack-plugin
module.exports = {"app":"_3AfZqluBzZxJKMzlpg4kQ1","appNotContent":"_39uH6BXvz5_npzEgm3ABVo","appContent":"F2Mxixabjje0eg9utxy-o","notContent":"vH67b7EhLZfOnULHCL_LK","notHome":"_3W2BBz7j52ngJ33sP9cagN","closeIcon":"_3JBBQCdRLqIPU0Gjhn8nfm"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/AppDesktop.scss
// module id = 1169
// module chunks = 0